import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ModalForm from '../modalForm';
import DevicesTable from '../devicesTable';
import BusinessPlansTable from '../businessPlansTable';
import { FieldWrapper, Button } from './css';

import {
  keyDevices,
  keySpareDevices,
  keyDevicesWereChanged,
  keyBusinessAppPlans
} from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const FieldButton = ({ data, orderData }) => {
  const {
    name,
    label,
    readonly,
    formFields,
    setFormFields,
    modalForms,
    dueNow,
    setDueNow,
    dueMonthly,
    setDueMonthly,
    setIsFormTouched,
    setIsFormValidated,
    isOrderFulfillmentTeam,
    isDevicesPromo
  } = data;
  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: { valuePaymentUpfront },
    modalForm: { modalFormDevices }
  } = localizedStrings;
  const [isModalOpened, setIsModalOpened] = useState(false);
  const modalForm =
    modalForms &&
    modalForms.length &&
    modalForms.find(item => item.fields.name === label);
  const modalFormFields =
    modalForm && modalForm.fields && modalForm.fields.formStepFields;
  const key = label === modalFormDevices ? keyDevices : keySpareDevices;
  const devices = formFields[key];
  const businessAppPlans = formFields[keyBusinessAppPlans] || [];
  const onDelete = index => {
    // Update dueNow and dueMonthly
    const item = devices[index];
    if (item.payForDevice === valuePaymentUpfront)
      setDueNow(dueNow - item.oneTimeCharges * item.quantity);
    else setDueMonthly(dueMonthly - item.monthlyCharges * item.quantity);

    // Update form fields
    devices.splice(index, 1);
    setFormFields({
      ...formFields,
      [key]: devices,
      [keyDevicesWereChanged]: true
    });
    setIsFormTouched(true);
    setIsFormValidated(false);
  };

  const onBusinessPlanDelete = index => {
    const item = businessAppPlans[index];
    if (item.payForDevice === valuePaymentUpfront)
      setDueNow(dueNow - item.oneTimeCharges * item.quantity);
    else setDueMonthly(dueMonthly - item.monthlyCharges * item.quantity);

    // Update form fields
    businessAppPlans.splice(index, 1);
    setFormFields({
      ...formFields,
      [businessAppPlans]: businessAppPlans,
    });
    setIsFormTouched(true);
    setIsFormValidated(false);
  };

  return (
    <FieldWrapper>
      {devices && devices.length > 0 && (
        <DevicesTable
          devices={devices}
          onDelete={isOrderFulfillmentTeam ? () => {} : onDelete}
        />
      )}
      {businessAppPlans && businessAppPlans.length > 0 && (
        <BusinessPlansTable
          businessAppPlans={businessAppPlans}
          onDelete={onBusinessPlanDelete}
          isDeletable
        />
      )}
      <Button
        type="button"
        name={name}
        onClick={() => setIsModalOpened(true)}
        className="frg-button color-green"
        disabled={readonly}
      >
        <span>{label}</span>
      </Button>
      <ModalForm
        fields={modalFormFields}
        formFields={formFields}
        setFormFields={setFormFields}
        dueNow={dueNow}
        setDueNow={setDueNow}
        dueMonthly={dueMonthly}
        setDueMonthly={setDueMonthly}
        open={isModalOpened}
        header={label}
        onClose={() => setIsModalOpened(false)}
        setIsFormTouched={setIsFormTouched}
        setIsFormValidated={setIsFormValidated}
        isDevicesPromo={isDevicesPromo}
        orderData={orderData}
      />
    </FieldWrapper>
  );
};

FieldButton.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    readonly: PropTypes.bool,
    formFields: PropTypes.objectOf(PropTypes.any),
    setFormFields: PropTypes.func,
    modalForms: PropTypes.arrayOf(PropTypes.object).isRequired,
    dueNow: PropTypes.number.isRequired,
    setDueNow: PropTypes.func.isRequired,
    dueMonthly: PropTypes.number.isRequired,
    setDueMonthly: PropTypes.func.isRequired,
    setIsFormTouched: PropTypes.func.isRequired,
    setIsFormValidated: PropTypes.func.isRequired,
    isOrderFulfillmentTeam: PropTypes.bool.isRequired,
    isDevicesPromo: PropTypes.bool.isRequired
  }).isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default FieldButton;
